module.exports = __webpack_public_path__ + "img/copyright-back.b8d5da3a.png";